import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  signal,
  input,
  output,
} from '@angular/core';
import { Params } from '@angular/router';
import { QarepaBaseSubsDirective } from '@qarepa/common';
import { EmployeeService } from '@qaroni-app/employee/services/employee.service';
import { Employee } from '@qaroni-app/employee/types/employee';

@Component({
  selector: 'qaroni-employees-filter',
  templateUrl: './employees-filter.component.html',
  styleUrl: './employees-filter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EmployeesFilterComponent
  extends QarepaBaseSubsDirective
  implements OnInit
{
  readonly companyID = input.required<number>();
  readonly multiple = input<boolean>(false);
  readonly firstOption = input<string>($localize`Todos`);
  readonly label = input<string>($localize`Empleados`);
  readonly queryParamName = input<string>(
    this.multiple ? 'employeeIds' : 'employeeId'
  );

  readonly queryParamsChange = output<Params>();

  private employeeService = inject(EmployeeService);

  private employees$ = this.employeeService.getEmployeesNames$();
  public $employees = signal<Employee[]>([]);

  ngOnInit(): void {
    this.subs.add(this.employees$.subscribe(this.getEmployees));
  }

  public onQueryParamsChange(params: Params): void {
    this.queryParamsChange.emit(params);
  }

  private getEmployees = (employees: Employee[]) => {
    if (!employees) {
      this.$employees.set([]);
      return;
    }

    const employeeOptions = employees.map(employee => ({
      ...employee,
      fullName: `${employee.firstName} ${employee.lastName}`,
    }));

    this.$employees.set(employeeOptions);
  };
}
